export interface PostCreateConversationResponse {
  conversation_id: string;
}

export interface PostMessageRequest {
  conversation_id: string;
  data: CreateTextMessageData | CreateVideoMessageData | CreateImageMessageData;
}

export interface PostGetDeletedMessagesRequest {
  messages_deleted_since_time?: string;
  conversation_id: string;
}

export interface PostDeletedMessagesResponse {
  deleted_message_ids: string[];
  checked_at_time: string;
}

export interface PostMessageResponse {
  message_id: string;
}

interface CreateTextMessageData {
  type: 'text';
  text: string;
}

interface CreateVideoMessageData {
  type: 'video';
  video_url: string;
}

interface CreateImageMessageData {
  type: 'image';
  image_url: string;
}

export interface GetLatestMessageFromAllClientsResponse {
  conversations: {
    conversation_id: string;
    latest_message: Message;
    last_read_message_id?: string;
  }[];
}
export interface PostGetMessagesRequest {
  conversation_id: string;
  less_than_index?: string;
  limit: number;
}

export interface PostGetMessagesResponse {
  messages: Message[];
  last_read_message_id?: string;
  has_more: boolean;
}

export interface PostSetConversationReadAtRequest {
  conversation_id: string;
  last_read_message_id: string;
}

export interface Conversation {
  conversation_id: string;
  user_ids: string[];
}

type MessageType = 'text' | 'video' | 'image';

interface MessageBase {
  id: string;
  sender_user_id: string;
  conversation_id: string;
  type: MessageType;
  created_at: string;
}

interface TextMessage extends MessageBase {
  type: 'text';
  text: string;
}

export interface VideoMessage extends MessageBase {
  type: 'video';
  video_url: string;
}

export interface ImageMessage extends MessageBase {
  type: 'image';
  image_url: string;
}

export type Message = TextMessage | VideoMessage | ImageMessage;

export const isMessage = (message?: any): message is Message => {
  return !!message && !!message.conversation_id && !!message.sender_user_id && !!message.type;
};

export interface NewMessageChatUpdate {
  type: 'new-message';
  message: Message;
}

export interface MessageDeletedChatUpdate {
  type: 'message-deleted';
  message_id: string;
}

export interface NewConversationChatUpdate {
  type: 'new-conversation';
  conversation_id: string;
  conversation_users: string[];
}

export type HevyChatUpdateMobilePushData =
  | NewMessageChatUpdate
  | MessageDeletedChatUpdate
  | NewConversationChatUpdate;
